import { render, staticRenderFns } from "./ImageCopper.vue?vue&type=template&id=5ec735a1&scoped=true&"
import script from "./ImageCopper.vue?vue&type=script&lang=js&"
export * from "./ImageCopper.vue?vue&type=script&lang=js&"
import style0 from "./ImageCopper.vue?vue&type=style&index=0&id=5ec735a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec735a1",
  null
  
)

export default component.exports